var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('InvestmentTransactionNavbar',{attrs:{"close-button-aria-label":_vm.closeButtonLabel,"is-back-button-visible":_vm.isBackButtonVisible},on:{"on-back":_vm.handleBackClick,"on-close":_vm.handleCloseClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }